import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedin,
  faTwitter,
  faFacebook,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import footerLogo from '../../assets/images/footer-logo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-columns">
          {/* About Section */}
          <div className="footer-col about-us">
            <div className="logo">
              <a href="/">
                <img
                  src={footerLogo}
                  alt="Praxiti Logo"
                  className="logo-img"
                  loading="lazy"
                />
              </a>
            </div>
            <p>
              A unique GenAI based platform that enables enterprises to drive
              innovation, automate processes and optimize decision making.
            </p>
          </div>

          {/* Contact Info */}
          <div className="footer-col contact-info">
            <h3>Contact Information</h3>
            <p>1018, Ist Main, 2nd Cross, Vijayanagar,</p>
            <p>Bengaluru, INDIA - 560040</p>
            <p>Email: info@praxiti.com</p>
            <p>Phone: +91 9611805311</p>
          </div>

          {/* Social Media */}
          <div className="footer-col social-media">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a
                href="https://www.linkedin.com/company/praxiti-technologies-private-limited/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a
                // href="https://twitter.com/Praxiti_AI"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                // href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                // href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                // href="https://youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>
          {/* <div className="footer-col social-media">
            <h4>Location</h4>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d299.00291288168165!2d77.545332338751!3d12.972677847680716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3de42be7fc0f%3A0xb8d5b4e9ccf85bc5!2s1018%2C%201st%20Main%20Rd%2C%20Hoshalli%20Extension%2C%20Stage%201%2C%20Vijayanagar%2C%20Bengaluru%2C%20Karnataka%20560040!5e1!3m2!1sen!2sin!4v1786081506770!5m2!1sen!2sin"
              width="280"
              height="150"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div> */}
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Praxiti. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
